var ur = window.location.href;
if(ur.includes('/pages/stressless-admiral-recliner')){
jQuery(document).ready(function(){
    
  var btnClass = ".product-form__submit";
  var prodTitle = ".featured-admiral .product__title";
  var prodPrice = "[id*=price-template]";
  var prodImg = ".product-media-container.constrain-height .media img";
  var prodTitleSvg = `
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.3997 5.3996C14.6926 5.10671 15.1674 5.10671 15.4603 5.3996L21.5303 11.4696C21.671 11.6103 21.75 11.801 21.75 11.9999C21.75 12.1988 21.671 12.3896 21.5303 12.5303L15.4603 18.6003C15.1674 18.8932 14.6926 18.8932 14.3997 18.6003C14.1068 18.3074 14.1068 17.8325 14.3997 17.5396L19.9393 11.9999L14.3997 6.46026C14.1068 6.16737 14.1068 5.69249 14.3997 5.3996Z" fill="#FDFDFD"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 11.9999C3.25 11.5857 3.58579 11.2499 4 11.2499H20.83C21.2442 11.2499 21.58 11.5857 21.58 11.9999C21.58 12.4141 21.2442 12.7499 20.83 12.7499H4C3.58579 12.7499 3.25 12.4141 3.25 11.9999Z" fill="#FDFDFD"/>
</svg>`;

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-image"></div><div class="simple-product-cont"><div class="simple-product-name"><p></p></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Shop Now</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());

jQuery(".simple-st-item__button").append(prodTitleSvg);

jQuery(".simple-product-image").append(jQuery(prodImg).eq(0).clone());

setTimeout(function(){ 
jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).html());
}, 1000);
  
 

  
  jQuery('.simple-st-item__button').click(function() {
    const target = document.querySelector('.product__info-container');

    if (target) {
        const yOffset = -50; 
        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
});
 
    
};

       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
};

$(document).ready(function () {
  function toggleStickyClass() {
    if ($('body').hasClass('simple-sticky')) {
      $('.widget-position-right .tidio-p32l1d, .widget-position-right.sidebar-position-right.dynamic div#button')
        .addClass('sticky');
    } else {
      $('.widget-position-right .tidio-p32l1d, .widget-position-right.sidebar-position-right.dynamic div#button')
        .removeClass('sticky');
    }
  }

  // Initial check
  toggleStickyClass();

  // MutationObserver for body class changes
  const observer = new MutationObserver(toggleStickyClass);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
});
